import {isProduction, getStyleSheets} from 'utils';

let themeCache = {};

export const clearCache = () => themeCache = {};

export const loadTheme = theme => {
    if (!isProduction()) return Promise.resolve();

    if (themeCache[theme]) return Promise.resolve();
    themeCache[theme] = true;

    const tag = document.createElement('link');
    tag.rel = 'stylesheet';
    tag.href = `${VWRAP.cdn}${VWRAP.fileName}-${theme}.css`;
    document.head.appendChild(tag);

    return new Promise(resolve => {
        let count = 0;
        const check = () => {
            const styleSheets = getStyleSheets();
            for (let i = 0; i < styleSheets.length; i++) {
                if (styleSheets[i].href === tag.href) return resolve();
            }
            if (++count < 10000) setTimeout(check, 1);
            // else reject('Theme CSS failed to load');
        };
        check();
    });
};



// WEBPACK FOOTER //
// ./scripts/themes.js